import { AppConstants } from "../../../../core/constants/constants";
import { SubscriptionsRepository } from "../../domain/repositories/SubscriptionsRepository";
import { SubscriptionsDataSource } from "../datasource/SubscriptionsDataSource";
import { SubscriptionPlan } from "../../domain/entities/SubscriptionPlan";
import { UserSubscription } from "../../domain/entities/UserSubscription";

export class SubscriptionsRepositoryImpl implements SubscriptionsRepository {
	constructor(private dataSource: SubscriptionsDataSource) {}

	getSubscriptionAll(): Promise<SubscriptionPlan[]> {
		return AppConstants.getRightOrLeftSide<SubscriptionPlan[]>(
			this.dataSource.getSubscriptionAll()
		);
	}

	createSubscriptionWithPaypal(subscription_id: string): Promise<string> {
		return AppConstants.getRightOrLeftSide<string>(
			this.dataSource.createSubscriptionWithPaypal(subscription_id)
		);
	}

	getSubscriptionByUser(): Promise<UserSubscription> {
		return AppConstants.getRightOrLeftSide<UserSubscription>(
			this.dataSource.getSubscriptionByUser()
		);
	}

	cancelSubscriptionWithPaypal(): Promise<void> {
		return AppConstants.getRightOrLeftSide<void>(
			this.dataSource.cancelSubscriptionWithPaypal()
		);
	}
}
